import { createMuiTheme } from '@material-ui/core/styles';

    const theme = createMuiTheme({
    palette: {
        primary: {
        main: '#009688',
        },
        secondary: {
        main: '#ffea00',
        },
    },
    });

  export default theme;
